// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header___oZXq","content":"layout_content__gAWyz","root":"layout_root__xi4wq"};